import { adminAPIService } from './index'

const route = 'configs'

export default {
  getConfig: () => adminAPIService({
    url: route,
    method: 'get',
  }),
  update(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
}
